import { Routing } from "@singularsystems/neo-core";
import { BrokerFileConfiguration, BrokerFileImportProcess, ColumnConfiguration, DataValidationConfiguration, Events, FileConfigurations, GenericMappings, Instruments, SecurityTransfers, ServiceProviders } from "../../AccessControl/Models/Commands/Security/Roles";
import { TextConstants } from "../../Common/TextConstants";
import CheckQuerySummaryView from "../CheckQueries/Views/CheckQuerySummaryView";
import ColumnConfigurationsView from "../ColumnConfigurations/Views/ColumnConfigurationsView";
import CorporateActionEventsView from "../CorporateActionEvents/Views/CorporateActionEventsView";
import FileGroupingFileSpecImportProceduresView from "../FileGroupingFileSpecImportProcedures/Views/FileGroupingFileSpecImportProceduresView";
import FileGroupingFileSpecView from "../FileGroupingFileSpecs/Views/FileGroupingFileSpecView";
import FileSpecConfigurationView from "../FileSpecConfigurations/Views/FileSpecConfigurationView";
import RawGenericMappingView from "../GenericMappings/Views/RawGenericMappingView";
import InstrumentsView from "../Instruments/Views/InstrumentsView";
import SecurityTransfersView from "../SecurityTransfer/Views/SecurityTransfersView";
import ServiceProviderFileGroupingsView from "../ServiceProviders/Views/ServiceProviderFileGroupingsView";
import StaticEventsView from "../StaticEvents/Views/StaticEventsView";
import ExportColumnConfigurationsView from "../ExportColumnSpecs/Views/ExportColumnConfigurationsView";
import CatalogueView from "../Catalogue/Views/CatologueView";
import OrganisationView from "../OrganisationMapping/OrganisationView";
import TradeOrderView from "../TradeOrders/Views/TradeOrderView";

const MaintenanceRoutes: Routing.IMenuRoute = {
    name: "Maintenance",
    expanded: false,
    icon: "wrench",
    exact: false,
    allowAnonymous:false,
    role: DataValidationConfiguration.Access,
    children: [
        {
            name: "Trade Orders",
            path: "/maintenance/tradeOrders",
            icon: "exchange-alt",
            component: TradeOrderView,
            allowAnonymous: false,
        },
        {
            name: "Corporate Action Events",
            path: "/maintenance/corporateActionEvents",
            icon: "building",
            component: CorporateActionEventsView,
            allowAnonymous: false,
        },
        {
            name: "Data Validation",
            path: "/maintenance/dataValidationConfiguration",
            icon: "check",
            component: CheckQuerySummaryView,
            allowAnonymous: false,
            role: DataValidationConfiguration.Access,
        },
        {
            name: "Events",
            path: "/maintenance/events",
            icon: "chart-line",
            component: StaticEventsView,
            allowAnonymous: false,
            role: Events.Access,
        },
        {
            name: "File Configuration",
            path: "/maintenance/fileConfiguration",
            icon: "file-code",
            component: FileSpecConfigurationView,
            allowAnonymous: false,
            role: FileConfigurations.Access,
            routeChildren: [
                {
                    name: "Broker File Specs",
                    path: "/maintenance/FileGroupingFileSpecs",
                    component: FileGroupingFileSpecView,
                    role: BrokerFileConfiguration.Access,
                    routeChildren: [
                        {
                            name: "Broker File Spec Import Procedures",
                            path: "/maintenance/importConfiguration",
                            component: FileGroupingFileSpecImportProceduresView,
                            role: BrokerFileImportProcess.Access
                        },
                    ]
                },
                {
                    name: "Column Configuration",
                    path: "/maintenance/ColumnConfigurations",
                    component: ColumnConfigurationsView,
                    role: ColumnConfiguration.Access
                },
                {
                    name: "Export Column Configuration",
                    path: "/maintenance/ExportColumnConfigurations",
                    component: ExportColumnConfigurationsView,
                    role: ColumnConfiguration.Access
                }
            ]
        },
        {
            name: "Generic Mappings",
            path: "/maintenance/genericMappings",
            icon: "table",
            component: RawGenericMappingView,
            allowAnonymous: false,
            role: GenericMappings.Access,
        },
        {
            name: TextConstants.Titles.Instruments,
            path: "/maintenance/Instruments",
            icon: "chart-line",
            component: InstrumentsView,
            allowAnonymous: false,
            role: Instruments.Access,
        },
        {
            name: "Security Transfers",
            path: "/maintenance/securityTransfers",
            icon: "exchange-alt",
            component: SecurityTransfersView,
            allowAnonymous: false,
            role: SecurityTransfers.Access,
        },
        {
            name: "Service Providers",
            path: "/maintenance/serviceProviders",
            icon: "briefcase",
            component: ServiceProviderFileGroupingsView,
            allowAnonymous: false,
            role: ServiceProviders.Access,
        },
        {
            name: "System Configuration",
            path: "/systemConfiguration",
            icon: "cog",
            component: CatalogueView,
            routeChildren: CatalogueView.getRouteChildren()
        },
        {
            name: "Organisation Management",
            path: "/maintenance/Organisation",
            icon: "cog",
            component: OrganisationView,
            role: GenericMappings.Access,
        },
    ]
}

const PureRoutes: Routing.IRoute[] = [

];

export {
    MaintenanceRoutes,
    PureRoutes
}